import React from "react";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";
import "./Approach.css";

/* -------- Inline SVG Icons (Construction) -------- */
const SafetyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 13c0-4.418 3.582-8 8-8s8 3.582 8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M3 14h18v2a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5v-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 10v4M14 10v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const QualityIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2l7 4v6c0 5-3.5 9.5-7 10-3.5-.5-7-5-7-10V6l7-4z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M8.5 12.5l2 2 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ScheduleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 2v4M16 2v4M3 9h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 12v4l3 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SustainabilityIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 22c-4.418 0-8-3.582-8-8 0-1.93.684-3.7 1.823-5.07C8 6 11 6 13.5 6.5 17 7 20 9 20 14c0 4.418-3.582 8-8 8z" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 16c-1.5-2.5-1-5 2-7 0 2-1 4-2 7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* -------- Content (Construction-Focused) -------- */
const points = [
  {
    title: "SAFETY & COMPLIANCE",
    text:
      "Zero-compromise site safety with daily toolbox talks, PPE, barricading, and adherence to local building codes and mandatory inspections.",
    icon: <SafetyIcon />
  },
  {
    title: "QUALITY ASSURANCE",
    text:
      "Stage-wise QA/QC—layout, foundation, structure, MEP, and finishing—with checklists, material certifications, and documented test results.",
    icon: <QualityIcon />
  },
  {
    title: "ON-TIME DELIVERY",
    text:
      "Critical-path scheduling, weekly look-ahead plans, and daily progress tracking to keep milestones on track from mobilization to handover.",
    icon: <ScheduleIcon />
  },
  {
    title: "SUSTAINABLE BUILDING",
    text:
      "Efficient resource planning, waste segregation, and energy-aware methods to minimize environmental impact without compromising durability.",
    icon: <SustainabilityIcon />
  }
];

const Approach = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.3 }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100, damping: 20 }
    }
  };

  return (
    <section className="approach-section">
      <div className="approach-container">
        {/* Left column */}
        <motion.div
          className="ap-left"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, margin: "-50px" }}
        >
          <h2 className="ap-title">Our Approach</h2>
          <p className="ap-lead">
            From pre-construction to handover, we plan, build, and finish with a
            safety-first mindset, rigorous quality control, transparent reporting,
            and predictable schedules. That’s how we deliver durable, code-compliant
            projects—on time.
          </p>

      
        </motion.div>

        {/* Right column */}
        <motion.div
          className="ap-right"
          initial="hidden"
          whileInView="visible"
          variants={containerVariants}
          viewport={{ once: true, margin: "-100px" }}
        >
          <div className="ap-grid">
            {points.map((p, i) => (
              <motion.article
                key={i}
                className="ap-item"
                variants={itemVariants}
                whileHover={{ y: -5 }}
              >
                <div className="ap-num">{String(i + 1).padStart(2, "0")}.</div>
                <div className="ap-item-body">
                  <div className="ap-item-header">
                    <span className="ap-item-icon">{p.icon}</span>
                    <h3 className="ap-item-title">{p.title}</h3>
                  </div>
                  <p className="ap-item-text">{p.text}</p>
                </div>
                <div className="ap-item-hover"></div>
              </motion.article>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Approach;
